import { pumaAPI } from "./api"
import { Concept } from "../models"
import { PumaParsedPaginatedResponse } from "./models/api/puma"

export const getConcepts = (): Promise<PumaParsedPaginatedResponse<Concept>> =>
    pumaAPI.getJSON("concepts", {})
